import React from 'react'
import './Contact.css'
import { MetaTags } from "react-meta-tags";
import ContactSection from './Inc/ContactSection'
const interiorWorkContent = [
  {
    descp1:
      `At Modern Towing, we are committed to providing top-notch towing services to ensure you receive the support you need whenever you face vehicle trouble. Located in Andheri, we understand how critical it is to have a reliable towing service available, especially during emergencies. Whether it's a minor breakdown or a more significant towing requirement, our expert team is always ready to assist.`,
    descp2:
      "If you're searching for Towing Services near Andheri, you've come to the right place. We offer a wide range of towing solutions tailored to your needs, ensuring safe and timely assistance for all types of vehicles. Our services cover everything from flatbed towing and hydraulic towing to luxury car towing and two-wheeler towing. No matter the situation, we have the equipment and expertise to handle it efficiently. Our team operates 24/7, making us your go-to provider for Towing Services near Andheri anytime, day or night.",
    descp3:
      `Please feel free to contact us using the information provided below.. Whether you need immediate assistance or have queries about our services, we're always here to help. You can visit our office in Andheri or give us a call for quick service. If you're looking for dependable Towing Services near Andheri, Modern Towing is the name you can trust.
We take pride in our customer-focused approach and always strive to ensure your vehicle is handled with care. With years of experience, a professional team, and state-of-the-art equipment, we guarantee prompt and reliable service. Contact Modern Towing today and experience our unparalleled support in towing services.
`,

  },
];
export default function Contact() {

  return (
    <>
      <MetaTags>
        <title>Towing Services near Andheri | Modern Towing</title>
        <meta title="Towing Services near Andheri | Modern Towing " />
        <meta name="description" content="Towing Services Mumbai, Car Towing Services in Andheri, Top Car Towing Services in Andheri West, Flatbed Towing Service in Andheri, Best Hydraulic Towing in Andheri, Two Wheeler Towing Services in Andheri, Top Car Towing Services For Luxury Car in Andheri, Truck Towing Services in Andheri, All Type Of Towing Services, Towing Services near Andheri " />
        <link rel="canonical" href="https://arogyayoghome.com/towing-services-near-andheri" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Towing Services near Andheri | Modern Towing " />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://arogyayoghome.com/" />
        <meta property="og:description" content="Need towing services near Andheri? Our fast and professional team offers 24/7 roadside assistance and towing solutions. Call us for reliable vehicle recovery!!!" />
        <meta property="og:image" content="https://kinararesort.in/static/media/logo.146c55d2a549f20e2963.png" />
      </MetaTags>
      <section className="page_breadcrumbs cs background_cover section_padding_top_40 section_padding_bottom_40">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-center custom-contact-col">
              <h2>Contact Us</h2>
              <ol className="breadcrumb">
                <li>
                  <a href="./">Home</a>
                </li>
                <li className="active">Contact Us</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className='special-padding' style={{paddingBottom:0}}>
        <section className="contact-project-version-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div style={{ marginBottom: 0 }} className="section-heading">
                  {/* <h6>| Our Gallery</h6> */}
                  <h2>Towing Services near Andheri</h2>
                </div>
                <div className="interior-work-container">
                  {interiorWorkContent.map((item, index) => (
                    <p key={index} className="interior-work-paragraph">
                      {item.descp1}
                      {item.descp2}
                    </p>
                  ))}
                </div>
                <div className="interior-work-container">
                  {interiorWorkContent.map((item, index) => (
                    <p key={index} className="interior-work-paragraph">
                      {item.descp3}
                      {item.descp4}
                    </p>
                  ))}
                </div>
                <div className="interior-work-container">
                  {interiorWorkContent.map((item, index) => (
                    <p key={index} className="interior-work-paragraph">
                      {item.descp5}
                    </p>
                  ))}
                </div>

              </div>
            </div>

          </div>
        </section>
        <ContactSection />


      </section>
      <section className="map-section">
          <div className='map-container'>
          <iframe
            className="map-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.862074096237!2d72.83648747497837!3d19.113705782098652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9db3696221f%3A0xdb0f59d4bad9fd70!2sModern%20Towing!5e0!3m2!1sen!2sin!4v1729342965132!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
            </div>
        </section>
    </>
  )
}
